import React, { useEffect, useState } from "react";

import { TextareaAutosize, Box, Chip, Button } from "@mui/material";
import { ASS_STATUS } from "../../../common/constants/status";

const StatusDashboard = ({ data }) => {
  const [submissions, setSubmission] = useState(null);
  const generateDashboardData = () => {
    const submissions = {
      miss: [],
      fail: [],
      error: [],
      resubmitted: [],
      outstanding: [],
    };
    data.forEach((item) => {
      // 'assignment'가 null인 경우 'miss'로 분류
      if (item.assignment === null) {
        submissions.miss.push(item.userId.name);
      } else {
        // 'assignment'가 존재하며, 상태별로 분류
        const state = item.assignment[item.assignment.length - 1].state;
        // submissions 객체에 해당 state가 없으면 초기화
        if (!submissions[state]) {
          submissions[state] = [];
        }
        submissions[state].push(item.userId.name);
      }
    });

    setSubmission(submissions);
  };
  const handleSlack = (nameList) => {
    const sentence = nameList.reduce((total, item) => {
      return (total += "@" + item + " ");
    }, "");
    return sentence;
  };
  useEffect(() => {
    generateDashboardData();
  }, [data]);
  if (!submissions) {
    return <h2>데이터 준비중...</h2>;
  }
  return (
    <Box sx={{ display: "flex" }} gap={2}>
      {Object.keys(submissions).map((status) => (
        <div key={status}>
          {status === "miss" ? (
            <Chip label={status} color="default" sx={{ mb: 1 }} />
          ) : (
            <Chip
              label={ASS_STATUS[status].message}
              color={ASS_STATUS[status].color}
              sx={{ mb: 1 }}
            />
          )}
          ({submissions[status].length})
          <div>
            <TextareaAutosize
              aria-label="improvement text"
              minRows={3}
              value={submissions[status]}
            />
          </div>
          {status === "miss" && (
            <TextareaAutosize
              aria-label="improvement text"
              minRows={3}
              value={handleSlack(submissions[status])}
            />
          )}
        </div>
      ))}
    </Box>
  );
};

export default StatusDashboard;
